var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagramSend = function SvgInstagramSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666664",
    d: "M19.013 1.044a.469.469 0 0 0-.485-.112L1.292 6.898a.469.469 0 0 0-.07.855l7.17 3.911 3.912 7.171a.469.469 0 0 0 .854-.071l5.967-17.236a.469.469 0 0 0-.112-.484Zm-2.104 1.44L8.654 10.74 2.601 7.437l14.308-4.952Zm-4.29 14.972-3.302-6.054 8.255-8.255-4.953 14.309Z"
  })));
};
export default SvgInstagramSend;